export const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
  
    // Check if only date (without time)
    if (dateString.length <= 10) {
      return date.toLocaleDateString(); // Just date
    }
  
    // Else, show date + time
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };
  